import { render } from "./CourseOutcomeScoresDialog.vue?vue&type=template&id=c5f32038"
import script from "./CourseOutcomeScoresDialog.vue?vue&type=script&lang=js"
export * from "./CourseOutcomeScoresDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__